import { RadioGroup } from '@headlessui/react';
import { classNames } from '@geerd-nx/utils';
import React from 'react';
interface GroupRadioProps {
  options: any[];
  onChange: () => (el: any) => void;
}
export default function GroupRadio({ options, onChange }: GroupRadioProps) {
  return (
    <RadioGroup
      onChange={(el) => {
        onChange()(el);
      }}
    >
      <div className="space-y-4">
        {React.Children.toArray(
          options.map((option) => (
            <RadioGroup.Option
              value={option}
              className={({ active }) =>
                classNames(
                  active || option.state
                    ? `${
                        option.state === 'selected'
                          ? 'border-blue-500'
                          : option.state === 'correct'
                          ? 'border-green-500'
                          : option.state === 'wrong'
                          ? 'border-red-500'
                          : ''
                      } ring-2 ${
                        option.state === 'selected'
                          ? 'ring-blue-500'
                          : option.state === 'correct'
                          ? 'ring-green-500'
                          : option.state === 'wrong'
                          ? 'ring-red-500'
                          : ''
                      } ${
                        option.state === 'selected'
                          ? 'bg-blue-300'
                          : option.state === 'correct'
                          ? 'bg-green-300'
                          : option.state === 'wrong'
                          ? 'bg-red-300'
                          : ''
                      }`
                    : '',
                  'relative block cursor-pointer rounded-lg border  px-4 py-2 shadow-sm focus:outline-none sm:flex sm:justify-between'
                )
              }
            >
              {({ active, checked }) => (
                <>
                  <span className="flex items-center">
                    <span className="flex flex-col text-sm">
                      <RadioGroup.Label
                        as="span"
                        className={`font-medium ${
                          option.state === 'selected'
                            ? 'text-blue-800'
                            : option.state === 'correct'
                            ? 'text-green-800'
                            : option.state === 'wrong'
                            ? 'text-red-800'
                            : ''
                        }`}
                      >
                        {option.label}
                      </RadioGroup.Label>
                    </span>
                  </span>

                  <span
                    className={classNames(
                      active ? 'border' : 'border-2',
                      checked
                        ? `${
                            option.state === 'selected'
                              ? 'border-blue-500'
                              : option === 'correct'
                              ? 'border-green-500'
                              : option === 'wrong'
                              ? 'border-red-500'
                              : ''
                          }`
                        : 'border-transparent',
                      'pointer-events-none absolute -inset-px rounded-lg'
                    )}
                    aria-hidden="true"
                  />
                </>
              )}
            </RadioGroup.Option>
          ))
        )}
      </div>
    </RadioGroup>
  );
}
